module.exports = __webpack_public_path__ + "media/images/GooglePlus_Transparent-f10829635fc78eaffab97a1d9536b9d7.png";